export default {
    PAGE: {
        NUTZUNGSARTEN: {
            INDEX: '/nutzungsarten',
        },
    },
    API: {
        NUTZUNGSARTEN: '/nutzungsarten',
    },
};
